import { Measure, useModelService } from 'services/model/model.service';

export function useProfitabilityMeasures() {
  const { getMeasures } = useModelService();
  return getMeasures([
    'netSlsGmvValExtExpOD',
    'cm1RateExtExpOD',
    'netSlsFeeRateExtExpOD',
    'cm2RateExtExpOD',
    'netSlsLogCostRateExtExpOD',
  ]);
}

export function toFeesAndCostsRateMeasure(slsFeeRate: Measure, netSlsLogCostRate: Measure): Measure {
  return {
    ...slsFeeRate,
    labelId: 'profitability.feesAndCosts.label',
    getValue: (values?: Record<string, number>) => slsFeeRate.getValue(values) + netSlsLogCostRate.getValue(values),
  };
}

export function toFeesAndCostsValueMeasure(slsFeeVal: Measure): Measure {
  return {
    ...slsFeeVal,
    labelId: 'profitability.feesAndCosts.label',
    getValue: (values?: Record<string, number>) =>
      (values?.netSlsFeeValExtExpOD ?? 0) + (values?.netSlsLogCostRateExtExpOD ?? 0),
  };
}
